<script setup lang="ts">
import { TooltipRoot as Tooltip, TooltipTrigger } from "reka-ui";
import { twMerge } from "tailwind-merge";
import TooltipContent from "@/components/ui/tooltip/TooltipContent.vue";
import SideNavContent from "./SideNavContent.vue";

defineProps<{
	isCollapsed: boolean;
}>();
</script>

<template>
	<aside
		:class="
			twMerge(
				'hidden inset-y fixed left-0 z-2 h-full flex-col border-r',
				$route.meta.hideSideNav ? 'md:hidden' : 'md:flex',
				$props.isCollapsed ? 'w-16' : 'w-64',
			)
		"
	>
		<SideNavContent :is-collapsed="$props.isCollapsed">
			<template #collapse>
				<Tooltip>
					<TooltipTrigger as-child>
						<button
							@click="$emit('toggle-collapsed')"
							class="w-6 h-6 absolute top-3 -right-3 border bg-background rounded-lg p-1"
						>
							<svg
								viewBox="0 0 16 16"
								class="line-icon"
								:class="$props.isCollapsed ? 'rotate-180' : ''"
							>
								<path d="M10 3l-5 5 5 5" />
							</svg>
						</button>
					</TooltipTrigger>
					<TooltipContent side="right">
						<p class="text-sm">
							{{ $props.isCollapsed ? "Expand" : "Collapse" }} Sidebar
						</p>
					</TooltipContent>
				</Tooltip>
			</template>
		</SideNavContent>
	</aside>
</template>
